import { FormField} from './field';

export class CheckboxField extends FormField {
    
    constructor(options: {} = {}) {
        super(options);
    }
}
